<template>
	<div class="">
		<div v-if="!isPlaying && !showHideButton" @click="$emit('setIsPlaying', true)"><PlaySvg /></div>
		<div v-else-if="isPlaying && !showHideButton" @click="$emit('setIsPlaying', false)"><PauseSvg /></div>
		<div v-else @click="onHide"><MinimizeSvg /></div>
	</div>
</template>

<script>
import MinimizeSvg from './assets/MinimizeSvg';
import PauseSvg from './assets/PauseSvg';
import PlaySvg from './assets/PlaySvg';

export default {
	name: 'PlayerController',
	components: {
		MinimizeSvg,
		PauseSvg,
		PlaySvg,
	},
	props: {
		isPlaying: { type: Boolean },
		isHidden: { type: Boolean },
		showHideButton: { type: Boolean },
	},
	computed: {},
	methods: {
		onHide() {
			this.$emit('setIsHidden', !this.isHidden);
		},
	},
};
</script>

<style lang="scss" scoped>
.dot-selector {
	$size: 10px;

	padding: 4px 0;

	&:hover {
		cursor: pointer;
	}
	.dot {
		height: $size;
		width: $size;
		margin-right: 8px;
		border-radius: 50%;
		background-color: #7e7fe7;
		transition: 0.3s;

		&:hover {
			background-color: white;
			transform: scale(1.2);
			transition: 0.2s;
		}
	}
}
</style>
